var render = function render(){
  var _vm$user$formacoesPen;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page--home"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    staticClass: "mt-8"
  }, [_c('v-col', [_c('CalendarioAnualFormacoes', {
    attrs: {
      "ano": _vm.anoCalendario,
      "eventos": _vm.eventosCalendario,
      "coresPorTipo": _vm.coresPorTipo,
      "mesInicio": _vm.mesInicio,
      "mesFinal": _vm.mesFinal,
      "anosDisponiveis": _vm.anosDisponiveis
    },
    on: {
      "abrirMes": _vm.irParaMes
    }
  })], 1)], 1)], 1), (_vm$user$formacoesPen = _vm.user.formacoesPendentes) !== null && _vm$user$formacoesPen !== void 0 && _vm$user$formacoesPen.length ? _c('ConfirmarFormacaoDialog', {
    attrs: {
      "dialogVisivel": true,
      "formacoes": _vm.user.formacoesPendentes,
      "usuario": _vm.user
    },
    on: {
      "onClose": function () {}
    }
  }) : _vm._e(), _c('DialogFormacoesDoMes', {
    attrs: {
      "visible": _vm.dialogFormacoesMes.visible,
      "formacoes": _vm.dialogFormacoesMes.formacoes,
      "mes": _vm.dialogFormacoesMes.mes,
      "ano": _vm.dialogFormacoesMes.ano
    },
    on: {
      "onClose": function ($event) {
        _vm.dialogFormacoesMes.visible = false;
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }